// src/components/BadgeMedal.js — médaillon de badge (placeholder SVG, à remplacer par le designer)
import React from "react";
import { CATEGORY_COLORS } from "../badges";

// Glyphes (dessinés en blanc, stroke). viewBox 0 0 24 24.
const GLYPHS = {
    bubbles: <><circle cx="9" cy="14" r="3.2" /><circle cx="15.5" cy="9" r="2.2" /><circle cx="17" cy="16" r="1.4" /></>,
    pin: <><path d="M12 21s6-5.3 6-10a6 6 0 1 0-12 0c0 4.7 6 10 6 10z" /><circle cx="12" cy="11" r="2.2" /></>,
    compass: <><circle cx="12" cy="12" r="8.5" /><polygon points="15.5,8.5 10.5,10.5 8.5,15.5 13.5,13.5" /></>,
    users: <><circle cx="9" cy="9" r="3" /><path d="M3.5 19a5.5 5.5 0 0 1 11 0" /><path d="M16 6.2a3 3 0 0 1 0 5.6" /><path d="M15.5 13.5a5.5 5.5 0 0 1 5 5.5" /></>,
    flag: <><path d="M6 21V4" /><path d="M6 4h11l-2 3.5L17 11H6" /></>,
    calendar: <><rect x="4" y="5.5" width="16" height="14" rx="2" /><path d="M4 9.5h16M8 3.5v4M16 3.5v4" /></>,
    drop: <><path d="M12 3.5S6 10 6 14a6 6 0 0 0 12 0c0-4-6-10.5-6-10.5z" /></>,
    layers: <><polygon points="12,3.5 21,8 12,12.5 3,8" /><polyline points="3,13 12,17.5 21,13" /></>,
    flame: <><path d="M12 3.5s5 4 5 8.5a5 5 0 0 1-10 0c0-2 1.5-3.5 1.5-3.5C9 10 12 8 12 3.5z" /></>,
    sun: <><circle cx="12" cy="12" r="4" /><path d="M12 2.5v2.5M12 19v2.5M2.5 12h2.5M19 12h2.5M5 5l1.8 1.8M17.2 17.2 19 19M19 5l-1.8 1.8M6.8 17.2 5 19" /></>,
    snow: <><path d="M12 3v18M4.2 7.5l15.6 9M19.8 7.5l-15.6 9" /></>,
    star: <><polygon points="12,3 14.6,9.2 21,9.7 16,14 17.6,20.5 12,17 6.4,20.5 8,14 3,9.7 9.4,9.2" /></>,
    moon: <><path d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z" /></>,
    check: <><circle cx="12" cy="12" r="8.5" /><polyline points="8.5,12.2 11,14.7 15.8,9.3" /></>,
    heart: <><path d="M12 20s-6.5-4.2-8.5-8.2C2 8.5 3.8 6 6.6 6c1.8 0 3 1.1 3.9 2.3C11.4 7.1 12.6 6 14.4 6c2.8 0 4.6 2.5 3.1 5.8C15.5 15.8 12 20 12 20z" /></>,
    gift: <><rect x="4" y="9.5" width="16" height="10.5" rx="1" /><path d="M2.5 9.5h19M12 9.5V20" /><path d="M12 9.5S9.5 4 7 5.4s.5 4.1 5 4.1zM12 9.5s2.5-5.5 5-4.1-.5 4.1-5 4.1z" /></>,
};

export default function BadgeMedal({ badge, earned = false, size = 56 }) {
    const color = earned ? (CATEGORY_COLORS[badge.cat] || "#0077b6") : "#c7d0d8";
    return (
        <div
            style={{
                width: size, height: size, borderRadius: "50%",
                background: earned ? color : "#eef2f4",
                border: `2px solid ${earned ? "rgba(255,255,255,0.6)" : "#dbe3e8"}`,
                boxShadow: earned ? `0 3px 10px ${color}55` : "none",
                display: "flex", alignItems: "center", justifyContent: "center",
                flexShrink: 0,
                filter: earned ? "none" : "grayscale(1)",
            }}
        >
            <svg width={size * 0.5} height={size * 0.5} viewBox="0 0 24 24" fill="none"
                stroke={earned ? "#fff" : "#9aa7b0"} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                {GLYPHS[badge.glyph] || GLYPHS.bubbles}
            </svg>
        </div>
    );
}
